
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinouterringroad() {



    const cardData =
    {
        keyword: '  Corporate Cab Services in Outer Ring Road ORR Corridor',
        heading: 'etravo : Corporate Cab Services in Outer Ring Road ORR Corridor',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Outer Ring Road (ORR) Corridor Bangalore, designed for IT companies, MNCs, startups, and professionals who require seamless transportation for daily employee commute, shift-based pickup and drop, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across the ORR tech corridor and surrounding business hubs.",

"top": "Top Corporate Cab Service Zones along Outer Ring Road (ORR) Bangalore with eTravo",

"topPlaces": [
  {
    "title": "Bellandur",
    "description": "A major IT and corporate hub on ORR hosting global tech parks and MNC offices requiring large-scale employee transportation."
  },
  {
    "title": "Marathahalli",
    "description": "A key connectivity point on ORR with high IT workforce density requiring daily corporate cab and shuttle services."
  },
  {
    "title": "HSR Layout",
    "description": "A residential-corporate zone where IT professionals rely on ORR connectivity for daily office commute and airport transfers."
  },
  {
    "title": "Sarjapur Road Junction",
    "description": "A rapidly growing IT corridor connected to ORR with tech parks and corporate offices requiring structured transport services."
  },
  {
    "title": "Kadubeesanahalli",
    "description": "A premium IT hub on ORR hosting major multinational companies requiring executive travel and employee shuttle services."
  },
  {
    "title": "Devarabeesanahalli",
    "description": "A key corporate cluster on ORR with tech campuses and office spaces requiring reliable daily cab services."
  },
  {
    "title": "Mahadevapura",
    "description": "An important IT zone on ORR with multiple tech parks requiring shift-based employee transportation."
  },
  {
    "title": "KR Puram",
    "description": "A major transit and residential hub connecting ORR to East Bangalore, supporting corporate commuting needs."
  },
  {
    "title": "Doddanekkundi",
    "description": "A growing IT and residential area on ORR with increasing demand for corporate cab services."
  },
  {
    "title": "Ecospace & Ecosystem Tech Park Belt",
    "description": "A high-density corporate zone on ORR requiring structured employee pickup, drop, and executive travel solutions."
  }
],


"services": [
{
"name": "Corporate Cab ORR Bangalore",
"description": "eTravo offers reliable corporate cab services on Outer Ring Road Bangalore designed for smooth business travel. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Outer Ring Road Bangalore",
"description": "Our taxi services on Outer Ring Road Bangalore provide quick and dependable transportation for professionals. eTravo ensures clean vehicles, timely service, and hassle-free travel across major IT hubs."
},
{
"name": "Company Cab ORR Corridor",
"description": "eTravo provides company cab services across the ORR corridor tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport ORR Bangalore",
"description": "Simplify employee commuting with eTravo’s office transport services on ORR Bangalore. We offer structured and efficient transportation solutions for daily travel across tech parks and offices."
},
{
"name": "Employee Cab Outer Ring Road",
"description": "Our employee cab services on Outer Ring Road are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel ORR Bangalore",
"description": "eTravo offers corporate travel services on ORR Bangalore for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab ORR",
"description": "eTravo’s business cab services on ORR are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport ORR Bangalore",
"description": "eTravo provides dependable staff transport services on ORR Bangalore for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient coordination."
},
{
"name": "Corporate Taxi ORR",
"description": "Our corporate taxi services on ORR offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi ORR Corridor",
"description": "eTravo’s company taxi services across the ORR corridor provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop ORR",
"description": "eTravo offers corporate pickup and drop services on ORR for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking ORR",
"description": "Book office cabs on ORR easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab ORR",
"description": "Our business travel cab services on ORR are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute ORR",
"description": "eTravo’s corporate commute services on ORR provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab ORR",
"description": "eTravo offers professional cab services on ORR with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab ORR Bangalore", "Taxi Outer Ring Road Bangalore"],
["Company Cab ORR Corridor", "Office Transport ORR Bangalore"],
["Employee Cab Outer Ring Road", "Corporate Travel ORR Bangalore"],
["Business Cab ORR", "Staff Transport ORR Bangalore"],
["Corporate Taxi ORR", "Company Taxi ORR Corridor"],
["Corporate Pickup Drop ORR", "Office Cab Booking ORR"],
["Business Travel Cab ORR", "Corporate Commute ORR"],
["Professional Cab ORR", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab ORR Bangalore Services",
      "WhyChoosedescription": "eTravo provides professional corporate cab ORR Bangalore services, ensuring seamless transportation for employees, executives, and business travelers across the Outer Ring Road corridor."
    },
    {
      "WhyChooseheading": "Perfect for ORR IT Corridor and Corporate Offices",
      "WhyChoosedescription": "The ORR corridor connects major tech hubs like Bellandur, Marathahalli, and Whitefield, making corporate cab services essential for office transport and employee commute."
    },
    {
      "WhyChooseheading": "Daily Office Transport ORR Bangalore",
      "WhyChoosedescription": "Our office transport ORR Bangalore solutions include structured pickup and drop services, ensuring employees reach workplaces on time with optimized routes."
    },
    {
      "WhyChooseheading": "Employee Cab Outer Ring Road with Shift Support",
      "WhyChoosedescription": "We provide employee cab outer ring road services for day, night, and rotational shifts, ensuring safe and reliable commuting for corporate teams."
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate and Business Travel",
      "WhyChoosedescription": "From sedans to SUVs and tempo travellers, our fleet supports corporate taxi ORR, business cab ORR, and staff transport ORR Bangalore requirements."
    },
    {
      "WhyChooseheading": "Flexible Corporate Pickup Drop ORR Plans",
      "WhyChoosedescription": "eTravo offers flexible corporate pickup drop ORR services including monthly contracts, daily bookings, and customized office cab booking ORR plans."
    },
    {
      "WhyChooseheading": "Technology-Enabled Professional Cab ORR",
      "WhyChoosedescription": "GPS tracking, route optimization, and centralized monitoring ensure efficient corporate commute ORR and safe transportation for employees."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel ORR Bangalore",
      "WhyChoosedescription": "Round-the-clock support ensures smooth coordination for company taxi ORR corridor, business travel cab ORR, and urgent corporate transport needs."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab ORR Bangalore services?',
            answer: 'Corporate cab ORR Bangalore services provide organized transportation for employees, executives, and clients across the Outer Ring Road corridor.',
        },
        {
            question: 'Do you provide office transport ORR Bangalore?',
            answer: 'Yes, we offer structured office transport ORR Bangalore services with daily pickup and drop for employees.',
        },
        {
            question: 'What is employee cab outer ring road service?',
            answer: 'It is a dedicated cab service for employee commuting across ORR locations with fixed routes and schedules.',
        },
        {
            question: 'Do you offer staff transport ORR Bangalore?',
            answer: 'Yes, we provide staff transport ORR Bangalore solutions for companies with multiple employees and shift-based operations.',
        },
        {
            question: 'Can I book corporate taxi ORR for business travel?',
            answer: 'Yes, corporate taxi ORR services are available for business meetings, client visits, and executive travel.',
        },
        {
            question: 'Do you provide corporate pickup drop ORR services?',
            answer: 'Yes, we offer daily and monthly corporate pickup drop ORR services for office commute.',
        },
        {
            question: 'Are company cab ORR corridor services available 24/7?',
            answer: 'Yes, services are available round the clock to support corporate schedules and shifts.',
        },
        {
            question: 'What types of vehicles are available for corporate travel ORR Bangalore?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and tempo travellers based on company requirements.',
        },
        {
            question: 'Can corporate commute ORR plans be customized?',
            answer: 'Yes, routes, timings, and plans can be customized for corporate clients.',
        },
        {
            question: 'How can I book office cab booking ORR?',
            answer: 'You can book through the website or contact the support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Kumar',
        designation: 'Operations Manager, IT Company, ORR Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab ORR Bangalore services. Their punctual pickups and route planning make daily commuting easy for our team.”',
    },
    {
        name: 'Ms. Anjali Shetty',
        designation: 'HR Manager, Tech Firm, ORR Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee cab outer ring road services. Their flexibility and reliable service ensure smooth office transport for our employees.”',
    },
];





    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Outer Ring Road ORR Corridor",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-orr-bangalore.jpg",
  "description": "Reliable corporate cab services in Outer Ring Road (ORR) Corridor, Bangalore by eTravo. Ideal for IT employee transport, office commute, corporate travel, staff pickup and drop, and business mobility solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-outer-ring-road-orr-corridor"
  }
};





    return (
        <div>


<Helmet>
  <title>Corporate Cab Services in ORR Bangalore | IT Corridor Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Outer Ring Road (ORR) Corridor, Bangalore with eTravo for IT employee transport, office commute, corporate travel, and pickup and drop services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/155.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinouterringroad;